// util
import { vuelidateUtil } from '@/utils/vuelidate-util';

// 3rd Party Libraries
import $ from 'jquery';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Services
import OrdersAPI from '@/app/services/main/orders/orders-service.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

export default {
	name: 'ModalOrdersModifyTrackingNumber',
	mixins: [ toastMessageMixins ],
	props: {
		mode: {
			type: String,
			required: true
		},
		order: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			trackingNumber: '',
			trackingLink: '',
			isAPILoading: false,
			sendEmailToggle: false
		}
	},
	watch: {
		order: {
			immediate: true,
			handler(newOrder) {
					this.sendEmailToggle = newOrder.sendTrackingEmail;
				}
			}
	},

	computed: {
		validationRules() {
			let field = {
				trackingNumber: {},
				trackingLink: {}
			};

			field = vuelidateUtil.setFieldsRequired(field, true);
			field = vuelidateUtil.setURLValidation(field, 'trackingLink');

			return field;
		},
		compareFields() {
			const compareTrackingNum = this.trackingNumber !== this.order.trackingNumber;
			const compareTrackingLink = this.trackingLink !== this.order.trackingLink;
			const compareSendEmailToggle = this.sendEmailToggle !== this.order.sendTrackingEmail;

			return compareTrackingLink || compareTrackingNum || compareSendEmailToggle
		},
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		openModal() {
			this.trackingNumber = '';
			this.trackingLink = '';
			this.$v.$reset();

			if (this.mode === 'update') {
				this.trackingNumber = this.order.trackingNumber;
				this.trackingLink = this.order.trackingLink;
				this.$v.$touch();
			}

			$(this.$refs.modalModifyTrackingNumber).modal('show');
		},
		closeModal() {
			$(this.$refs.modalModifyTrackingNumber).modal('hide');
			this.sendEmailToggle = this.order.sendTrackingEmail
		},
		submitTrackingNumber() {
			if (this.$v.$invalid) {
				return;
			}

			this.isAPILoading = true;
			const body = {
				trackingNumber: this.trackingNumber,
				trackingLink: this.trackingLink,
				sendEmail: this.sendEmailToggle
			}

			OrdersAPI.putOrderTrackingNumber(this.order.id, body)
				.then(res => {

					const { SUCCESS_ORDER_TRACKING, ERROR_ORDER_TRACKING } = this.toastMessages.order(this.mode === 'add' ? 'added' : 'updated');

					if (res.status === STATUS_CODES.SUCCESS) {
						this.showCustomSuccessToast(null, SUCCESS_ORDER_TRACKING);
						this.$emit('getTableContent');
						this.closeModal();
					} else {
						this.showAPIErrorToast(ERROR_ORDER_TRACKING, res);
					}

					this.isAPILoading = false;
				});
		}
	},
	validations() {
		return this.validationRules;
	}
}